import { render } from "./BusinessList.vue?vue&type=template&id=35f38733&scoped=true"
import script from "./BusinessList.vue?vue&type=script&lang=js"
export * from "./BusinessList.vue?vue&type=script&lang=js"

import "./BusinessList.vue?vue&type=style&index=0&id=35f38733&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f38733"]])

export default __exports__